import { render, staticRenderFns } from "./HkiaraceCardDisplayFrame.vue?vue&type=template&id=36d87d5c"
import script from "./HkiaraceCardDisplayFrame.vue?vue&type=script&lang=js"
export * from "./HkiaraceCardDisplayFrame.vue?vue&type=script&lang=js"
import style0 from "./HkiaraceCardDisplayFrame.vue?vue&type=style&index=0&id=36d87d5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports